// extracted by mini-css-extract-plugin
module.exports = {"trackingNumbersField":"ConsignmentCommandForm_trackingNumbersField__1u3K9","locationTips":"ConsignmentCommandForm_locationTips__3z5nN"};